import ClockIcon from "@mui/icons-material/AccessTimeOutlined";
import type { SelectChangeEvent } from "@mui/material";
import { InputAdornment, MenuItem, Select, Typography } from "@mui/material";
import { emailTrackingStatusFilterValues } from "../emailDeliveryLogState";

interface Props {
  filterValue: string;
  onChange: (filterValue: string) => void;
}

const StatusSelect = ({ filterValue, onChange }: Props) => {
  const handleChange = (e: SelectChangeEvent) => onChange(e.target.value);

  return (
    <Select
      value={filterValue}
      onChange={handleChange}
      startAdornment={
        <InputAdornment position="start">
          <ClockIcon color="action" />
        </InputAdornment>
      }
      displayEmpty
      sx={{
        width: "14rem",
        ".MuiInputBase-input": {
          color: filterValue ? "text.primary" : "text.secondary",
        },
      }}
      renderValue={(value) => value || "Status"}
    >
      {emailTrackingStatusFilterValues.map((value) => (
        <MenuItem key={value} value={value}>
          <Typography>{value}</Typography>
        </MenuItem>
      ))}
    </Select>
  );
};

export default StatusSelect;
